import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Col, Container, Row, Card, CardHeader, CardBody, Input, Label, Table, Button } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import Select from "react-select";
import MyEditor from "../../../Components/editor/MyEditor";
import { SUBDOMAIN, SITE_ID } from "../../../assets/meta/meta";
import { API } from "../../../api/client";
import moment from "moment";
import ImagesUploader from "../../../Components/editor/ImagesUploader";
import DictListEditor from "../../../Components/editor/DictListEditor";
import { useAuthContext } from "../../../Components/AuthContext";
import { findMissingRequiredFields, focusFirstMissingField, formatRequiredMessage } from "@/utils/formRequired";
import { dialogService } from "@/utils/dialogService";
import { useUnsavedChangesGuard } from "@/hooks/useUnsavedChangesGuard";
const ShoppingProductForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isCopyMode = searchParams.get("copy") === "true";
    const fileInputRef = React.useRef(null);
    const detailImgFileInputRef = React.useRef(null);
    const [name, setName] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [price, setPrice] = React.useState(0);
    const [summary, setSummary] = React.useState("");
    const [infoNotice, setInfoNotice] = React.useState("");
    const [infoNoticeList, setInfoNoticeList] = React.useState([]);
    const [noSalePrice, setNoSalePrice] = React.useState(0);
    const [saleRate, setSaleRate] = React.useState(0);
    const [imageUrl, setImageUrl] = React.useState("");
    const [image, setImage] = React.useState("");
    const [detailImgUrl, setDetailImgUrl] = React.useState("");
    const [detailImg, setDetailImg] = React.useState("");
    const [productState, setProductState] = React.useState(null);
    const [availableStartDate, setAvailableStartDate] = React.useState(null);
    const [availableEndDate, setAvailableEndDate] = React.useState(null);
    const [count, setCount] = React.useState(0);
    const [siteOptions, setSiteOptions] = React.useState([]);
    const [availableSite, setAvailableSite] = React.useState({
        value: SITE_ID,
        label: SUBDOMAIN
    });
    const [groupKey, setGroupKey] = useState(Math.random().toString(16).slice(2));
    const [images, setImages] = useState([]);
    const [categoryOptions, setCategoryOptions] = React.useState([]);
    const [category, setCategory] = React.useState(null);
    const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
    const { userInfo } = useAuthContext();
    const markDirty = React.useCallback(() => setHasUnsavedChanges(true), []);
    const { confirmDiscardChanges } = useUnsavedChangesGuard({
        isDirty: hasUnsavedChanges,
        confirmNavigation: dialogService.confirm,
    });
    useEffect(() => {
        console.log("availableSite", availableSite);
    }, [availableSite]);
    const onImageUploaded = (data) => {
        markDirty();
        setImages(data);
    };
    const fetchSiteOptions = () => {
        API.get('/sites/camps/')
            .then((response) => {
            const _sites = response.data
                .filter((item) => !!item.subdomain)
                .map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setSiteOptions(_sites);
        })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    };
    const handleImageFiles = (e) => {
        const files = e.target.files;
        if (files.length !== 0) {
            setImage(files[0]);
        }
    };
    const handleDetailImgFiles = (e) => {
        const files = e.target.files;
        if (files.length !== 0) {
            setDetailImg(files[0]);
        }
    };
    React.useEffect(() => {
        if (id !== "0" && siteOptions.length > 0) {
            API.get(`/shop/product/${id}`)
                .then((response) => fillStates(response.data, isCopyMode))
                .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
        }
    }, [id, siteOptions, isCopyMode]);
    const fillStates = (data, copyMode = false) => {
        console.log("fillStates", data);
        setName(copyMode ? data["name"] + " (복사)" : data["name"]);
        setDescription(data["descript"]);
        setSummary(data["summary"]);
        setInfoNotice(data["info_notice"]);
        setInfoNoticeList(data["info_notice_list"]);
        setNoSalePrice(data["no_sale_price"]);
        setSaleRate(data["sale_rate"]);
        if (!copyMode) {
            setImageUrl(data["thumbnail"]);
            setDetailImgUrl(data["detail_img"]);
            setImages(data["images"]);
        }
        else {
            setGroupKey(Math.random().toString(16).slice(2)); // New group key for copy
            setImages([]);
        }
        setAvailableStartDate(data["available_start_date"]);
        setAvailableEndDate(data["available_end_date"]);
        setProductState(data["state"]);
        setPrice(data["price"]);
        setCount(data["stock_count"]);
        if (data["site"]) {
            const _site = siteOptions.find((item) => item.value === data["site"]);
            if (_site)
                setAvailableSite({
                    value: _site.value,
                    label: _site.label,
                });
        }
        if (!copyMode) {
            setGroupKey(data["group_key"]);
        }
    };
    const sendData = async () => {
        const [formData, jsonData] = await checkData();
        if (formData === null)
            return;
        API.post('/shop/product/', formData, {
            headers: { "content-type": "multipart/form-data" }
        })
            .then((res) => {
            return API.patch(`/shop/product/${res.data.id}/`, jsonData);
        })
            .then(async () => {
            setHasUnsavedChanges(false);
            await dialogService.handleAlert("상품이 등록되었습니다");
            navigate('/shopping-product-list');
        })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    };
    const updateData = async () => {
        const [formData, jsonData] = await checkData();
        if (formData === null)
            return;
        API.patch(`/shop/product/${id}/`, formData, {
            headers: { "content-type": "multipart/form-data" }
        })
            .then(() => {
            return API.patch(`/shop/product/${id}/`, jsonData);
        })
            .then(async () => {
            setHasUnsavedChanges(false);
            await dialogService.handleAlert("상품이 수정되었습니다");
            navigate('/shopping-product-list');
        })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    };
    const getDate = (dateObj) => {
        if (typeof dateObj === "string")
            return dateObj;
        console.log(dateObj);
        let date = dateObj[0].getFullYear() + "-" + (dateObj[0].getMonth() + 1) + "-" + dateObj[0].getDate();
        return date;
    };
    const checkData = async () => {
        const missingRequiredFields = findMissingRequiredFields([
            { label: "상품명", value: name, elementId: "name" },
            { label: "금액", value: price, elementId: "formPrice" },
            { label: "상세설명", value: description, elementId: "descriptionEditor" },
        ]);
        if (missingRequiredFields.length > 0) {
            await dialogService.handleAlert(formatRequiredMessage(missingRequiredFields));
            focusFirstMissingField(missingRequiredFields);
            return [null, null];
        }
        let data = new FormData();
        data.append("name", name);
        if (image)
            data.append("thumbnail", image);
        if (detailImg)
            data.append("detail_img", detailImg);
        data.append("descript", description);
        if (availableStartDate)
            data.append("available_start_date", getDate(availableStartDate));
        if (availableEndDate)
            data.append("available_end_date", getDate(availableEndDate));
        data.append("state", productState);
        data.append("price", String(price));
        data.append("stock_count", String(count));
        if (summary)
            data.append("summary", summary);
        if (infoNotice)
            data.append("info_notice", infoNotice);
        if (infoNoticeList)
            data.append("info_notice_list", JSON.stringify(infoNoticeList));
        if (noSalePrice)
            data.append("no_sale_price", String(noSalePrice));
        if (saleRate)
            data.append("sale_rate", String(saleRate));
        const jsondata = {
            name: name,
            descript: description,
            available_start_date: availableStartDate ? getDate(availableStartDate) : null,
            available_end_date: availableEndDate ? getDate(availableEndDate) : null,
            state: productState,
            stock_count: count ? count : 0,
            price: price,
            site: availableSite.value,
            images: images.map((_image) => _image.id),
            group_key: groupKey,
            summary: summary,
            info_notice: infoNotice,
            info_notice_list: infoNoticeList,
            no_sale_price: noSalePrice,
            sale_rate: saleRate,
        };
        return [data, jsondata];
    };
    React.useEffect(() => {
        fetchSiteOptions();
        API.get('/shop/category/')
            .then((response) => {
            const _categories = response.data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setCategoryOptions(_categories);
        })
            .catch(async (error) => await dialogService.handleAlert(error.message, { force: "error" }));
    }, []);
    return (<React.Fragment>
      <div className="page-content" onChangeCapture={markDirty} onInputCapture={markDirty}>
        <Container fluid>
          <BreadCrumb title="쇼핑몰 상품 등록 및 수정" pageTitle="목록"/>

          <Row className="g-4 mb-3">
            <div className="col-sm-auto">
              <div>
                <h4 className="card-title mb-0 flex-grow-1">상품 등록 및 수정</h4>
              </div>
            </div>
            <div className="col-sm-3 ms-auto">
              <div className="d-flex justify-content-sm-end gap-2">
                {(id === "0" || isCopyMode) ? (<Button color="success" className="add-btn me-1" onClick={sendData} id="create-btn">
                    생성
                  </Button>) : (<Button color="success" className="add-btn me-1" onClick={updateData} id="update-btn">
                    수정
                  </Button>)}
                <Button color="danger" className="add-btn me-1" onClick={async () => {
            if (!await confirmDiscardChanges())
                return;
            navigate(`/shopping-product-list`);
        }} id="cancel-btn">
                  Cancel
                </Button>
              </div>
            </div>
          </Row>

          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <div className="live-preview">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="firstNameinput" className="form-label">
                            상품명
                          </Label>
                          <Input type="text" className="form-control" placeholder="상품명" id="name" value={name} onChange={(e) => setName(e.target.value)} maxLength="50"/>
                        </div>
                      </Col>
                      <Col md={4}>
                        {imageUrl ? (<div>
                            <img src={`${imageUrl}`} alt="상품이미지" width="100%" style={{ maxHeight: "200px" }}/>
                          </div>) : null}
                        <div>
                          <Label htmlFor="formFile" className="form-label">
                            상품이미지
                          </Label>
                          <Input className="form-control" type="file" id="formFile" accept="image/jpg, image/jpeg, image/png" ref={fileInputRef} onChange={handleImageFiles}/>
                        </div>
                      </Col>
                      <Col md={4}>
                        {detailImgUrl ? (<div>
                            <img src={`${detailImgUrl}`} alt="상품 상세이미지" width="100%" style={{ maxHeight: "200px" }}/>
                          </div>) : null}
                        <div>
                          <Label htmlFor="detailImgFile" className="form-label">
                            상품 상세이미지
                          </Label>
                          <Input className="form-control" type="file" id="detailImgFile" accept="image/jpg, image/jpeg, image/png" ref={detailImgFileInputRef} onChange={handleDetailImgFiles}/>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formStartDate" className="form-label">
                            판매게시일
                          </Label>
                          <CommonDatePicker value={availableStartDate} onChange={(value) => {
            markDirty();
            setAvailableStartDate(value);
        }} className="form-control" options={{
        }}/>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formEndDate" className="form-label">
                            판매종료일
                          </Label>
                          <CommonDatePicker value={availableEndDate} onChange={(value) => {
            markDirty();
            setAvailableEndDate(value);
        }} className="form-control" options={{
        }}/>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formProductState" className="form-label">
                            상품상태
                          </Label>
                          <Select name="productState" options={[
            { value: "노출중", label: "노출중" },
            { value: "숨김", label: "숨김" },
            { value: "품절", label: "품절" },
        ]} className="basic-multi-select" classNamePrefix="select" onChange={(e) => {
            markDirty();
            setProductState(e.value);
        }} value={{ value: productState, label: productState }}/>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formPrice" className="form-label">
                            금액
                          </Label>
                          <Input type="number" className="form-control" placeholder="할인금액" id="formPrice" value={price} onChange={(e) => setPrice(Number(e.target.value))}/>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formCount" className="form-label">
                            재고수량
                          </Label>
                          <Input type="number" className="form-control" placeholder="수량" id="count" value={count} onChange={(e) => setCount(Number(e.target.value))}/>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formCategory" className="form-label">
                            카테고리
                          </Label>
                          <Select name="category" options={categoryOptions} className="category-select" classNamePrefix="select" onChange={(e) => {
            markDirty();
            setCategory(e);
        }} value={category}/>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formNoSalePrice" className="form-label">
                            할인 전 금액
                          </Label>
                          <Input type="number" className="form-control" placeholder="할인 전 금액" id="formNoSalePrice" value={noSalePrice} onChange={(e) => setNoSalePrice(Number(e.target.value))}/>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="formsaleRate" className="form-label">
                            할인율
                          </Label>
                          <Input type="number" className="form-control" placeholder="할인율" id="formsaleRate" value={saleRate} onChange={(e) => setSaleRate(Number(e.target.value))}/>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <Col lg={12} className="mb-3" style={{ paddingLeft: "28px" }}>
                    <h5 className="card-title mb-0">상품 이미지 (캐로셀)</h5>
                    {userInfo ? <ImagesUploader groupKey={groupKey} userId={userInfo.id} onUploaded={onImageUploaded} endpoint="shop/product-image"/> : null}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xxl={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">상세설명</h4>
                </CardHeader>
                <CardBody>
                  <div id="descriptionEditor" tabIndex={-1}>
                    <MyEditor value={description} onChange={(value) => {
                      markDirty();
                      setDescription(value);
                    }} noImage={true} uid="MyEditor-description"/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xxl={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">상품 정보 고시</h4>
                </CardHeader>
                <CardBody>
                  <div>
                    <DictListEditor data={infoNoticeList} onChange={(value) => {
                      markDirty();
                      setInfoNoticeList(value);
                    }} uid="DictListEditor-infoNotice"/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>);
};
export default ShoppingProductForm;
